import bookingSlice from "./reducer/bookingSlice";

const rootReducer = {
  booking: bookingSlice,
};

export default rootReducer;
